<template>
    <div class='app-container'>
        <el-card class="search-form-card">

            <el-form :inline="true" :model="searchRequery" class="search-form" label-width="80px">
                
                <!-- 应用搜索 -->
                <el-form-item>
                    <el-input v-model="searchRequery.app_name" placeholder="应用搜索"></el-input>
                </el-form-item>

                <!-- 开始时间范围 -->
                <el-form-item>
                    <el-date-picker
                        v-model="searchRequery.start_time"
                        type="datetimerange"
                        start-placeholder="开始时间范围"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>

                <!-- 生成的bag -->
                <el-form-item>
                    <el-input v-model="searchRequery.create_tag" placeholder="生成的tag"></el-input>
                </el-form-item>

                <!-- 部署状态 -->
                <el-form-item>
                    <el-select v-model="searchRequery.deploy_status" clearable placeholder="部署状态">
                        <el-option
                         v-for="(item, index) in search_criteria.deploy_status"
                         :key="index"
                         :label="item.name"
                         :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 结束时间范围 -->
                <el-form-item>
                    <el-date-picker
                     v-model="searchRequery.end_time"
                     type="datetimerange"
                     start-placeholder="结束时间范围"
                     value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                
                <!-- 发布的tag -->
                <el-form-item>
                    <el-input v-model="searchRequery.deploy_tag" placeholder="发布的tag"></el-input>
                </el-form-item>

                <!-- 审批状态 -->
                <el-form-item>
                    <el-select v-model="searchRequery.work_status" clearable placeholder="审批状态">
                        <el-option
                         v-for="(item, index) in search_criteria.work_status"
                         :key="index"
                         :label="item.name"
                         :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 环境 -->
                <el-form-item>
                    <el-input v-model="searchRequery.env" placeholder="环境"></el-input>
                </el-form-item>

                <!-- 上线单标题 -->
                <el-form-item>
                    <el-input v-model="searchRequery.title" placeholder="上线单标题"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="Search">搜索</el-button>
                </el-form-item>

                <el-form-item>
                    <el-button type="info" icon="el-icon-delete" @click="Cancel">取消</el-button>
                </el-form-item>

            </el-form>

        </el-card>

        <el-card>
           <!-- <div slot="header" v-w-role="'cicdCxjcFblsFbcj'">
               <router-link :to="{ path:'/deployNew', query: { callback: fetchData }}">
                   <el-button type="primary">创建</el-button>
               </router-link>
           </div> -->

            <!-- 排班表格 -->
            <el-table v-loading='tableLoading' :data="deployinfo" style="width: 100%" type='index'>

                <!-- id -->
                <el-table-column label="id" prop="id" width='60px'></el-table-column>

                <!-- 应用 -->
                <el-table-column label="应用" prop="app" width='160px'></el-table-column>

                <!-- 上线单标题 -->
                <el-table-column label="上线单标题" prop="title"></el-table-column>

                <!-- 环境 -->
                <el-table-column label="环境">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.env | tableVal(env) }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 开始时间 -->
                <el-table-column label="开始时间" prop="start_time"></el-table-column>

                <!-- 结束时间 -->
                <el-table-column label="结束时间" prop="end_time"></el-table-column>

                <!-- 用时 -->
                <el-table-column label="用时" prop="use_times"></el-table-column>

                <!-- 发布的分支/tag -->
                <el-table-column label="发布的分支/tag" prop="branch"></el-table-column>

                <!-- 生成的tag -->
                <el-table-column label="生成的tag" prop="tag"></el-table-column>

                <!-- 部署机器 -->
                <el-table-column label="部署机器" prop="tag">
                    <template slot-scope="{row}">
                        <span>
                            {{ typeof(row.target_value) === "object"?row.target_value.join(','):row.target_value}}
                            <!-- {{typeof(row.target_value)}} -->
                        </span>
                    </template>
                </el-table-column>

                <!-- 部署状态 -->
                <el-table-column label="部署状态" prop="deploy_status">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.deploy_status | tableVal(build) }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 审批状态 -->
                <el-table-column label="审批状态">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.work_status | tableVal(approval) }}
                        </span>
                    </template>
                </el-table-column>
                
                <!-- 操作 -->
                <el-table-column label="操作" fixed="right" width="210">
                    <template slot-scope="scope">
                        <!-- <router-link :to="{ path: '/appcenterTree/integration/buildLog', query: { 
                            id: scope.row.app_id,
                            selfId: scope.row.id,
                            type: 'router'
                         } }"> -->
                            <el-button type='text' @click='buildLog(scope.row)'>控制台页面</el-button>
                        <!-- </router-link> -->
                    </template>
                </el-table-column>

            </el-table>

             <!-- 分页器 -->
            <Pagination 
                v-show="total>0" 
                :total="total" 
                :page.sync="listQuery.page_num" 
                :limit.sync="listQuery.page_size"
                @pagination="fetchData">
            </Pagination>

        </el-card>
    </div>
</template>

<script>
    import services from './cicd.services'
    import Pagination from '../../components/Pagination'
    import { setInterval, clearInterval } from 'timers'

    export default {
        components: { Pagination },

        data() {
            return {
                searchRequery: {
                    start_time: [],
                    end_time: []
                },
                total: 0,
                tableLoading: true,
                listQuery: {
                    page_num: 1,
                    page_size: 10
                },
                deployinfo: [],
                search_criteria: {},
                timer: null,
                params: {}
            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            build() {
                return this.dictionary.build
            },
            env() {
                return this.dictionary.env
            },
            approval() {
                return this.dictionary.approval
            }
        },

        mounted() {
            this.timer = setInterval(() => {
                let params = {
                    ...this.params,
                    page_num: this.listQuery.page_num,
                }
                this.fetchData(null, params);
            }, 2000)
            this.fetchData();
            services.deploySearch().then(
                res => this.search_criteria = { ...res },
                err => this.$message.error(err.message)
            )
        },
        
        methods:{
            buildLog(row) {
                this.$router.push({
                    name: 'BuildLog',
                    params: {
                        id: row.app_id,
                        selfId: row.id,
                        type: 'router'
                    }
                })
            },

            // 控制台页面
            checkJournal(ind) { 
                this.$router.push({
                    query: {ind},
                    path: '/deployLine'
                })
            },

            // 请求
            fetchData(content, params) {
                if (content) {
                    params = {
                        ...params,
                        page_num: content.page,
                        page_size: content.limit
                    }
                }
                services.deployList(params)
                    .then(res => {
                            this.tableLoading = false
                            this.deployinfo = res.data
                            this.total = res.total
                            this.listQuery.page_num = res.page_num
                        })
                    .catch(err => this.$message.error(err.message))
            },
            
            // 搜索
            Search() { 
                this.params = {
                    ...this.searchRequery,
                    start_time_start: this.searchRequery.start_time[0],
                    start_time_stop: this.searchRequery.start_time[1],
                    end_time_start: this.searchRequery.end_time[0],
                    end_time_stop: this.searchRequery.end_time[1]
                }
                this.fetchData(null, this.params)
            },
            
            // 取消
            Cancel() {
                this.searchRequery = {
                    start_time: [],
                    end_time: []
                }
            },
        },

        destroyed() {
            clearInterval(this.timer)
        },
    }
</script>

<style lang="scss" scoped>
</style>
